/**
 * Footer-link adapter for CodeStitch footer link lists.
 *
 * Footer link lists use the SAME `ul.cs-ul > li.cs-li` idiom as the header nav,
 * so this adapter is region-scoped to the footer (`requiredAncestorSelector`)
 * and the nav adapter is region-scoped to the header — the two never collide.
 *
 * Footers mix layouts: a plain `.cs-ul` is a vertical column while a `.cs-ul-1`
 * is a row-wrapped list. `reorderAxis:'flow'` resolves the concrete axis from
 * the dragged list's live computed layout at drag start, so each list reorders
 * along its own visual direction.
 */

import { moveSiblingPreservingEids } from '../element-insert.js';

export const footerLinkAdapter = {
  kind: 'footer-link',
  label: 'Footer link',
  itemSelector: 'li.cs-li',
  parentSelector: 'ul.cs-ul',
  reorderSelector: 'ul.cs-ul > li.cs-li',
  reorderSiblingSelector: 'ul.cs-ul > li.cs-li',
  // Region scope: the broad `ul.cs-ul > li.cs-li` also matches header nav links.
  // Constrain footer-link drags to the footer so they never fire the nav path
  // (and Phase 0b constrains nav to the header, closing the collision both ways).
  requiredAncestorSelector: 'footer, [id^="cs-footer"]',
  // Per-instance axis: vertical .cs-ul vs row-wrapped .cs-ul-1.
  reorderAxis: 'flow',
  historyLabel: 'Reorder footer link',
  toastText: 'Footer link reordered',
  vtPrefix: 'pb-foot-',
  vtSelector: 'ul.cs-ul > li.cs-li',
  moveFn: moveSiblingPreservingEids,
  menuActions: ['duplicate', 'delete'],
  postInsertFlow: null,
  cssPatch: null,
  reorderable: true,

  match(probe) {
    if (!probe || typeof probe.closest !== 'function') return null;
    // Only classify footer link items — a header nav li.cs-li stays nav-link.
    if (!probe.closest('footer')) return null;
    return probe.closest('li.cs-li');
  }
};
